import { useMutation } from '@tanstack/react-query'
import {
  CreateProductMasterBatchJobPresignedUrlRequest,
  CreateProductMasterBatchJobPresignedUrlResponse,
  MasterApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'

type Params = {
  masterUuid: string
  request: CreateProductMasterBatchJobPresignedUrlRequest
}

export const useMutationGenerateMasterBatchJobPresignedUrl = () => {
  return useMutation({
    mutationFn: async ({
      masterUuid,
      request,
    }: Params): Promise<CreateProductMasterBatchJobPresignedUrlResponse> => {
      const api = baseClient.getApi(MasterApi)
      return await api
        .generateMasterBatchJobPresignedUrl({
          masterUuid,
          createProductMasterBatchJobPresignedUrlRequest: request,
        })
        .catch(handleHTTPError)
    },
  })
}
